import { useRef } from 'react';

export default function useArrayMemo<T>(array: T[]): T[] {
  const ref = useRef(array);
  const isEqual = ref.current.length === array.length && ref.current.every((value, index) => value === array[index]);

  if (!isEqual) {
    ref.current = array;
  }

  return ref.current;
}
